import React, { useState } from "react";
import { migrateFonctionsParLoge } from "./migrations/migrationFonctionsParLoge.ts";

export default function Migration() {
    const [running, setRunning] = useState(false);
    const [result, setResult] = useState<any>(null);
    const [error, setError] = useState<string>("");

    const run = async () => {
        setRunning(true);
        setError("");
        setResult(null);
        try {
            const res = await migrateFonctionsParLoge();
            setResult(res);
        } catch (e: any) {
            setError(e?.message || "Erreur migration");
        } finally {
            setRunning(false);
        }
    };

    return (
        <div style={{ padding: 20 }}>
            <h2>Migration: fonctionsParLoge</h2>

            <p>
                Cette migration cr�e/compl�te <b>fonctionsParLoge</b> pour tous les
                membres et garantit <b>loges[]</b>.
            </p>

            <button onClick={run} disabled={running}>
                {running ? "Migration en cours..." : "Lancer la migration (1 fois)"}
            </button>

            {error && <div style={{ color: "red", marginTop: 12 }}>{error}</div>}

            {result && (
                <pre style={{ marginTop: 12, background: "#f5f5f5", padding: 12 }}>
                    {JSON.stringify(result, null, 2)}
                </pre>
            )}
        </div>
    );
}
